import { useMediaQuery } from "@mui/material";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useDispatch } from "react-redux";
import * as config from "../../../config/config";
import { fetchEmployerPlatformCard } from "../../../redux/actions/company_action";
import { updateContactUsEmployer } from "../../../redux/actions/dialog_action";
import content_my from "./content_my.json";
import content_sg from "./content_sg.json";
import {
  BoxStyled,
  ButtonStyled,
  CardStyled,
  CardTextStyled,
  CoverImageStyled,
  ImageBoxStyled,
  ImageStyled,
  InnerSectionContainer,
  SectionContainer,
  SubTitleContainer,
  TextOther,
  TextStyled,
  TitleContainer,
} from "./styles";

function EmployerLandingPlatform() {
  const router = useRouter();
  const [platformItem, setPlatformItem] = useState([]);
  const isDesktop = useMediaQuery("(max-width:1280px)");
  const isTablet = useMediaQuery("(max-width:768px)");
  const dispatch = useDispatch();

  async function fetchData() {
    const responseApi = await dispatch(fetchEmployerPlatformCard());

    const isMalaysia = process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "my";
    const response = isMalaysia ? content_my : content_sg;

    const { platformCard } = response || {};

    setPlatformItem([platformCard]);
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <SectionContainer id="platform">
      <InnerSectionContainer>
        <TitleContainer>
          <TextOther>HIREDLY X</TextOther>

          <SubTitleContainer>
            <TextStyled
              type={"title"}
              dangerouslySetInnerHTML={{
                __html:
                  "Prefer a <i>recruitment service</i> instead of posting jobs?",
              }}
            ></TextStyled>
            <TextStyled type={"desc"}>Look no further.</TextStyled>
          </SubTitleContainer>
        </TitleContainer>

        <BoxStyled
          display={"flex"}
          flexDirection={isTablet ? "column" : "column"}
          justifyContent={"center"}
          alignItems={"flex-start"}
          gap={"40px"}
          width={"100%"}
        >
          {platformItem?.map((item, index) => (
            <CardStyled
              sx={{ background: "#dfccf3" }}
              border={isDesktop ? "1.5px solid #000" : "2px solid #000"}
              key={index}
            >
              <CoverImageStyled src={item?.coverImage?.data?.attributes?.url} />
              <BoxStyled
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"flex-end"}
                gap={isMobile ? "24px" : "16px"}
                alignSelf={"stretch"}
                flex={"1 0 0"}
              >
                <BoxStyled
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"flex-start"}
                  gap={"16px"}
                  alignSelf={"stretch"}
                  flex={"1 0 0"}
                >
                  <BoxStyled
                    display={"flex"}
                    flexDirection={isDesktop ? "row" : "column"}
                    alignItems={isMobile ? "center" : "flex-start"}
                    gap={isDesktop ? "16px" : "12px"}
                    alignSelf={"stretch"}
                  >
                    <ImageBoxStyled
                      borderRadius={"8px"}
                      border={"0.5px solid #000"}
                      style={{ background: "#FFF" }}
                    >
                      <ImageStyled
                        src={
                          config.assetDomain +
                          "/images/employer_landing/hiredly-x-logo.webp"
                        }
                      />
                    </ImageBoxStyled>

                    <CardTextStyled>{item?.title}</CardTextStyled>
                  </BoxStyled>

                  <CardTextStyled type={"desc"}>
                    {item?.description}
                  </CardTextStyled>
                </BoxStyled>

                <BoxStyled
                  display={"flex"}
                  justifyContent={isTablet ? "center" : "flex-end"}
                  gap={"15px"}
                  width={"100%"}
                >
                  <ButtonStyled
                    white
                    target="_blank"
                    onClick={() =>
                      dispatch(
                        updateContactUsEmployer({
                          state: true,
                          origin: "contact-us-banner",
                          prefilled: "Headhunting",
                        })
                      )
                    }
                  >
                    Speak to Recruiter
                  </ButtonStyled>

                  <ButtonStyled
                    target="_blank"
                    onClick={() => router.push("/hiredly-x")}
                  >
                    View more details
                  </ButtonStyled>
                </BoxStyled>
              </BoxStyled>
            </CardStyled>
          ))}
        </BoxStyled>
      </InnerSectionContainer>
    </SectionContainer>
  );
}

export default EmployerLandingPlatform;
